<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Promotional Material</h3>
                  </div>
                </div>
              </div>
              <template v-if="imgArr.length">
                <div class="row row-sm">
                  <div
                    v-for="(imgLink,idx) in imgArr"
                    :key="idx"
                    class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                  >
                    <div class="card card-file">
                      <div class="dropdown-file">
                        <a href class="dropdown-link" data-toggle="dropdown">
                          <i class="fa fa-ellipsis-v"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a target="_blank" :href="imgLink" class="dropdown-item">
                            <i class="fa fa-eye"></i>&nbsp;View
                          </a>
                          <a
                            @click="downloadImage(imgLink,'pm-waajo-'+idx)"
                            href="javascript:void(0)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-download"></i>&nbsp;Download
                          </a>
                        </div>
                      </div>
                      <div class="text-center">
                        <img :src="imgLink" :style="'width:80%;'" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

import VueSimpleAlert from "vue-simple-alert";
import { downloadImage } from "@/utils/helper";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false,
      isLoadingImages: false,
      isLoadingInfo: false,
      referralLink: "",
      imgArr: [],
      infoArr: {
        id: 0,
        referral_code: "",
        referral_join_datetime: 0,
        referral_bonus: 0,
        target_omzet: 0,
        update_datetime: 0
      }
    };
  },
  async created() {
    this.images();
  },
  methods: {
    downloadImage(url, title) {
      return downloadImage(url, title);
    },

    images() {
      this.isLoadingImages = true;
      this.$store
        .dispatch("referral/images")
        .then(response => {
          this.isLoadingImages = false;
          this.imgArr = response.data;
        })
        .catch(() => {
          this.isLoadingImages = false;
        });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/link.vue